// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import DebitOtherCreditPanelRowBody from './debit-other-credit-panel-row-body';
import DebitOtherCreditPanelRowHeader from './debit-other-credit-panel-row-header';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {buildNumber} from '../../../../shared/services/build-number';

function handleAdjustmentValueChange(itemNumber, value) {

    this.actions.updateAdjustmentValue(itemNumber, value);

}

function handleAdjustmentTypeChange(itemNumber, type) {

    this.actions.updateAdjustmentType(itemNumber, type, this.adjustmentTypes);

}

const DebitOtherCreditPanel = props =>
    props.credits.length > 0 &&
        <section className='debit-other-credit-panel'>
            <header className='debit-other-credit-panel-title'>
                <FormattedMessage
                    id='OTHER_CREDITS_WITH_COUNT'
                    values={{
                        count: buildNumber(props.credits.length)
                    }}
                />
            </header>
            <DebitOtherCreditPanelRowHeader/>
            <section className='credit-list'>
                {props.credits.map((credit, index) =>
                    <DebitOtherCreditPanelRowBody
                        adjustmentTypes={props.adjustmentTypes}
                        credit={credit}
                        isEditable={props.isEditable}
                        key={index}
                        onAdjustmentTypeChange={handleAdjustmentTypeChange.bind(props, credit.itemNumber)}
                        onAdjustmentValueChange={handleAdjustmentValueChange.bind(props, credit.itemNumber)}
                    />
                )}
            </section>
        </section>;

DebitOtherCreditPanel.displayName = 'DebitOtherCreditPanel';
DebitOtherCreditPanel.propTypes = {
    actions: PropTypes.object,
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    credits: PropTypes.arrayOf(PropTypes.instanceOf(DebitItem)).isRequired,
    isEditable: PropTypes.bool.isRequired
};

export default DebitOtherCreditPanel;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-other-credits-panel/debit-other-credit-panel.js